import { Helmet } from 'react-helmet-async';

const BASE_URL = typeof window !== 'undefined' ? window.location.origin : '';
// Canonical defaults to the CURRENT page (never the homepage) so pages that don't pass `url` aren't mis-canonicalised.
const currentUrl = () => (typeof window !== 'undefined' ? window.location.origin + window.location.pathname : '');

const SEO = ({
  title = 'Gangadhar Som - Artist Portfolio',
  description = 'Renowned professional artist Gangadhar Som, with 40+ years in fine arts and South Indian cinema. Creator of 46 Lord Hanuman life history paintings at Karya Siddhi Hanuman Temple, Dallas. Publicity designer for 900+ movies. Honored with the title Datta Peetha Asthan Chitrakara.',
  keywords = 'Gangadhar Som, Indian artist, Hanuman paintings, devotional art, Dallas temple, oil paintings, acrylics, watercolors, film poster art, temple paintings, portrait painting, 900 movies',
  image = null,   // no site-wide default image is shipped; pages with artwork pass one
  url = currentUrl(),
  type = 'website',
  schema = null,
  price = null,
  currency = 'INR',
  availability = null,
  noindex = false, // private / thin pages (cart, checkout, account, tracking)
}) => {
  const defaultSchema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "name": "Gangadhar Som",
        "url": BASE_URL,
        "potentialAction": { "@type": "SearchAction", "target": `${BASE_URL}/gallery?search={search_term_string}`, "query-input": "required name=search_term_string" },
      },
      {
        "@type": "Person",
        "@id": `${BASE_URL}/#artist`,
        "name": "Gangadhar Som",
        "jobTitle": "Artist",
        "description": description,
        "url": BASE_URL,
        ...(image ? { "image": image } : {}),
        "knowsAbout": ["Oil Painting", "Acrylics", "Watercolors", "Spray Painting", "Digital Illustration", "Devotional Art", "Religious Art", "Indian Art", "Film Poster Art", "Portrait Painting"],
        "award": ["Datta Peetha Asthan Chitrakara", "Gold Medal - Loyola College Chennai", "A.P. Balala Academy Award", "Tamil Nadu Forest Department Award"],
        "birthPlace": "Podur, West Godavari, Andhra Pradesh, India",
        "birthDate": "1961-10-21",
        "sameAs": [
          "https://www.instagram.com/gangadharsom",
          "https://www.facebook.com/gangadharsom",
          "https://www.youtube.com/@gangadharsom",
          "https://in.pinterest.com/gangadharsom"
        ].filter(Boolean),
      },
    ]
  };

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Gangadhar Som" />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow, max-image-preview:large'} />
      <meta name="language" content="English" />
      <meta property="og:locale" content="en_IN" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      {image && <meta property="og:image" content={image} />}
      <meta property="og:site_name" content="Gangadhar Som" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      {image && <meta property="twitter:image" content={image} />}

      {/* Pinterest Rich Pins */}
      <meta name="pinterest-rich-pin" content="true" />
      {price && <meta property="product:price:amount" content={String(price)} />}
      {price && <meta property="product:price:currency" content={currency} />}
      {availability && <meta property="product:availability" content={availability} />}

      {!noindex && <link rel="canonical" href={url} />}

      {!noindex && (
        <script type="application/ld+json">
          {JSON.stringify(schema || defaultSchema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
